import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

const useLocationBlocker = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentLocationId = getLocationId(location);

    const preventNavigation = (newLocation) => {
      if (getLocationId(newLocation) === currentLocationId) {
        return false; // Aynı sayfaya gitmekten kaçının
      }
      return true; // Farklı bir sayfa için devam edin
    };

    // Here you can add logic to control navigation based on preventNavigation
    // This might involve handling a navigation event, or triggering navigation
    // conditionally in your app's code based on preventNavigation

  }, [location, navigate]);
};

const getLocationId = ({ pathname, search, hash }) => {
  return pathname + (search ? "?" + search : "") + (hash ? "#" + hash : "");
};

export default useLocationBlocker;

